// @flow
import type { TDraftLeaguesReducer } from '../league';
import type { TRoundsReducer } from '../round';
import type { TVenuesReducer } from '../venues';
import type { TPlayersReducer  } from './playersReducer';

import type { TUserReducer } from "./userReducer";
import type { TSquadsReducer } from "./squadsReducer";
import type { TPositionsReducer } from "./positionsReducer";
import type { TPlayerStatusesReducer } from "./playerStatusesReducer";
import type { TTeamsDraftReducer } from "./teamsDraftReducer";
import type { TCoachStatsListReducer } from "./coachStatsListReducer";
import type { TUiMenuReducer } from "./uiMenuReducer";
import type { TUiSelectedLeagueReducer } from "./uiSelectedLeagueReducer";
// import type { TTeamsDraftTradesReducer } from './teamsDraftTradesReducer';

export type TRootStore = {
	positions: TPositionsReducer,
	user: TUserReducer,
	squads: TSquadsReducer,
	players: TPlayersReducer,
	playerStatuses: TPlayerStatusesReducer,
	teamsDraft: TTeamsDraftReducer,
	rounds: TRoundsReducer,
	venues: TVenuesReducer,
	leagues: TDraftLeaguesReducer,
	coachStatsList: TCoachStatsListReducer,
	uiMenu: TUiMenuReducer,
	uiSelectedLeague: TUiSelectedLeagueReducer,
	notifications: {
		counter: number,
		notification_bar: {
			text: string,
			show: boolean
		}
	}
};

export * from "./userReducer";
export * from "./squadsReducer";
export * from "./positionsReducer";
export * from "./playerStatusesReducer";
export * from "./teamsDraftReducer";
export * from "./coachStatsListReducer";
export * from "./uiMenuReducer";
export * from './teamsDraftTradesReducer';


// WEBPACK FOOTER //
// ./src/modules/types/store/index.js